"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexBuilderRequests = void 0;
const Paths_1 = require("../Paths");
const Utils_1 = require("../Utils");
const IndexUtils_1 = require("./IndexUtils");
const OptionsHandler_1 = require("./IndexUtils/OptionsHandler");
class IndexBuilderRequests {
    constructor(session, appInfo) {
        this.session = session;
        this.appInfo = appInfo;
        this.deakoOptions = new OptionsHandler_1.OptionsHandler(this.appInfo);
    }
    getBuilderList() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = {
                method: Paths_1.Methods.GET,
            };
            const requestBuilt = yield (0, Utils_1.buildGenericRequest)(this.session, request, this.deakoOptions);
            const endpoint = (0, IndexUtils_1.getBuilderEndpoint)();
            const resp = yield (0, Utils_1.wrapFetchJson)(requestBuilt, endpoint);
            return (0, IndexUtils_1.cleanBuilderList)(resp.builders);
        });
    }
}
exports.IndexBuilderRequests = IndexBuilderRequests;
//# sourceMappingURL=IndexBuilderRequests.js.map